export const PRODUCTS_ACTION_HIDE = "PRODUCTS_ACTION_HIDE";
export const PRODUCTS_ACTION_PUSH_DOWN = "PRODUCTS_ACTION_PUSH_DOWN";
export const PRODUCTS_ACTION_VISIBLE = "PRODUCTS_ACTION_VISIBLE";
export const PRODUCTS_ACTION_PUSH_DOWN_VISIBLE = "PRODUCTS_ACTION_PUSH_DOWN_VISIBLE";
export const PRODUCTS_NO_ACTION = "PRODUCTS_NO_ACTION";

export const actionTypes = {
  PRODUCTS_ACTION_HIDE: "Hidden",
  PRODUCTS_ACTION_PUSH_DOWN: "Pushed Down",
  PRODUCTS_ACTION_VISIBLE: "Made visible",
  PRODUCTS_ACTION_PUSH_DOWN_VISIBLE: "Pushed Up"
};